<template>
  <div class="mall-info-row">
    <span class="mall-info-row__label">{{ label }}</span>
    <span class="mall-info-row__value">
      <span v-for="line in valueLines" :key="line" class="mall-info-row__line">{{ line }}</span>
    </span>
  </div>
</template>

<script>
// 항목명 + 오른쪽 정렬 값 (배송 정보 등)
export default {
  name: 'MallInfoRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    // 문자열 또는 줄 단위 배열
    value: {
      type: [String, Array],
      default: '',
    },
  },
  computed: {
    valueLines() {
      return Array.isArray(this.value) ? this.value : [this.value]
    },
  },
}
</script>

<style scoped>
.mall-info-row {
  display: flex;
  padding: 0 4px;
  align-items: flex-start;
  gap: 10px;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-info-row__label {
  color: #6B7684;
  white-space: nowrap;
}

.mall-info-row__value {
  flex: 1;
  min-width: 0;
  color: var(--color-text-main);
  text-align: right;
  overflow-wrap: anywhere;
}

.mall-info-row__line {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallInfoRow.vue